import React, {Component} from "react";
import {connect} from "react-redux";
import PropTypes from "prop-types";
import Template from "./Template";
import withErrorBoundary from "../../decorators/withErrorBoundary";
import withColorHexMapContext from "../../decorators/withColorHexMapContext";
import withMobileContext from "../../decorators/withMobileContext";
import {conditionSelector, productSelector} from "../../selectors";
import productSettings from "../../services/product-settings";
import {changeVariant} from "../../AC/change-variant";
import {setBackgroundColor} from "../../AC/set-background-color";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import CloseIcon from "@material-ui/icons/Close";
import IconButton from "@material-ui/core/IconButton";
import NoSsr from "@material-ui/core/NoSsr";
import trackEvent from "../../../../utils/track-event";

class VariantControl extends Component {
  static propTypes = {
    product: PropTypes.object,
    colorHexMap: PropTypes.object,
    condition: PropTypes.object,
    changeVariant: PropTypes.func,
    setBackgroundColor: PropTypes.func,
    isMobile: PropTypes.bool
  };
  state = {
    isOpen: false
  };
  palette = React.createRef();
  content = React.createRef();
  changeVariant = (e, variant, val, forAllSides) => {
    if (variant !== `background`) {
      this.props.changeVariant(variant, val);
      this.setState({
        isOpen: false
      });
    } else {
      if (val.r || val.r === 0) {
        const {r, g, b} = val;
        this.props.setBackgroundColor(`rgb(${r}, ${g}, ${b})`, forAllSides);
      } else {
        this.props.setBackgroundColor(val, forAllSides);
        this.setState({
          isOpen: false
        });
      }
    }
    trackEvent({
      category: `Editor`,
      action: `Item variant change`,
      label: val
    });
  };
  toggleVariants = (e) => {
    const paletteNode = this.palette.current;
    const contentNode = this.content.current;
    if (paletteNode && !contentNode) {
      this.setState({
        isOpen: paletteNode.contains(e.target) ? !this.state.isOpen : false
      });
      if (paletteNode.contains(e.target)) {
        trackEvent({
          category: `Editor`,
          action: `Item variant click`
        });
      }
    } else if (paletteNode && contentNode) {
      this.setState({
        isOpen: paletteNode.contains(e.target)
          ? !this.state.isOpen
          : contentNode.contains(e.target)
      });
    }
  };
  componentDidMount() {
    document.addEventListener(`mousedown`, this.toggleVariants.bind(this));
  }
  componentWillUnmount() {
    document.removeEventListener(`mousedown`, this.toggleVariants.bind(this));
  }
  componentDidUpdate() {
    if (window && !window.localStorage.getItem(`is-open-variants-control`)) {
      window.localStorage.setItem(`is-open-variants-control`, true);
      this.setState({
        isOpen: true
      });
    }
  }
  getBackground() {
    const {colorHexMap, product, condition} = this.props;
    const firstVariant =
      productSettings[condition.product] &&
      productSettings[condition.product].variants &&
      productSettings[condition.product].variants[0];
    if (firstVariant && firstVariant.keyInProductMeta) {
      const items = product.meta[firstVariant.keyInProductMeta];
      const filterOfItemsBy = /(white)|(-handle)|(-inside)/;
      const itemsMap =
        firstVariant.name === `color` || firstVariant.name === `mug_color`
          ? colorHexMap
          : void 0;
      const val = condition.variants[firstVariant.name];
      if (itemsMap) {
        if (filterOfItemsBy && val.indexOf(`-`) > -1) {
          return itemsMap[val.replace(filterOfItemsBy, ``)];
        }
        return itemsMap[val];
      }
      return `url(${items[val]})`;
    } else {
      return this.getColorFromDesign();
    }
  }
  getColorFromDesign() {
    const {
      condition: {design}
    } = this.props;
    if (design && design.background) {
      return design.background;
    }
    return `transparent`;
  }
  render() {
    const {condition, product, colorHexMap, isMobile} = this.props;
    const {isOpen} = this.state;
    const settings = productSettings[condition.product];
    const background = this.getBackground();
    return settings && settings.variants ? (
      <div className="variants">
        <div className="variants__label" ref={this.palette}>
          <div className="variants__title">{settings.variants[0].title}</div>
          <div
            className={`variants__fill variants__fill_${
              settings.variants[0].name
            }${
              background === `transparent` ? ` variants__fill_transparent` : ``
            }`}
            style={{
              [background.indexOf(`url`) > -1
                ? `backgroundImage`
                : `backgroundColor`]: background,
              backgroundPosition: ` center center`
            }}
          >
            <NoSsr>
              <ArrowDropDownIcon />
            </NoSsr>
          </div>
        </div>
        {isOpen && (
          <div className="variants__content" ref={this.content}>
            {settings.variants.map((variant, i) => {
              return (
                <Template
                  key={`${variant.name}-${i}`}
                  name={variant.template}
                  currentVariants={condition.variants}
                  productMeta={product.meta}
                  changeVariant={this.changeVariant}
                  colorHexMap={colorHexMap}
                  variant={variant}
                  withoutTitle={i === 0}
                />
              );
            })}
            {isMobile && (
              <div className="variants__close">
                <NoSsr>
                  <IconButton
                    onClick={() => {
                      this.setState({isOpen: false});
                    }}
                  >
                    <CloseIcon />
                  </IconButton>
                </NoSsr>
              </div>
            )}
          </div>
        )}
      </div>
    ) : null;
  }
}
export default connect(
  (state) => ({
    condition: conditionSelector(state),
    product: productSelector(state)
  }),
  {
    changeVariant,
    setBackgroundColor
  }
)(withErrorBoundary(withColorHexMapContext(withMobileContext(VariantControl))));
